import { Head, usePage } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { rootPath, signupPath } from "@travily/routes";
import type HomesShow from "@travily/types/pages/HomesShow";
import { useFavoritedIdsCallbacks } from "@/hooks/use-search-favorites";
import { PageFrame } from "@/layouts/page-frame";
import type { SharedProps } from "@/types";
import { ShowView } from "./show.view";

const HomePage = ({ destinations, families, listings, programs, favorited_ids }: HomesShow) => {
  const { current_user } = usePage<SharedProps>().props;
  // Server favorite state lives in the `favorited_ids` prop rather than on
  // the (shared, once-cached) records; layer the optimistic hook on top.
  const { getFavorited, onFavoriteToggle } = useFavoritedIdsCallbacks(favorited_ids);

  return (
    <PageFrame stickyTopBar={false}>
      <Head title={t("web.homes.show.meta_title")}>
        <meta name="description" content={t("web.homes.show.meta_description")} />
      </Head>
      <ShowView
        destinations={destinations}
        families={families}
        getFavorited={getFavorited}
        isAuthenticated={!!current_user}
        joinHref={signupPath()}
        learnMoreHref={rootPath()}
        onFavoriteToggle={onFavoriteToggle}
        listings={listings}
        programs={programs}
      />
    </PageFrame>
  );
};

export default HomePage;
